import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useStores } from "../../models/helpers/useStores"
import { observer } from "mobx-react-lite"
import { isMobile, isTablet } from "react-device-detect"
import { LoadingScreen } from "./LoadingScreen"
import Config from "../../config"
import UnsupportedMobileVersion from "./UnsupportedMobileVersion"

export const PrivateRoute = observer(({ children }: { children: ReactNode }) => {
  const { loggedInUser, agentProfile, isAuthLoading, isTripLoading } = useStores()

  const isNotDesktop = isMobile || isTablet

  if (isNotDesktop && Config.environment !== "development") {
    return <UnsupportedMobileVersion />
  }

  if (isAuthLoading || isTripLoading) {
    return <LoadingScreen />
  }

  if (loggedInUser && agentProfile) {
    return children
  }

  if (loggedInUser && !agentProfile) {
    return <Navigate to="/signup" />
  }

  return <Navigate to="/" />
})
